import { formatearFecha } from "../../../../helpers/formatearFecha";

// Motivo por el que el producto padre no puede registrar cierres: sin
// producción desde el último cierre, o sin producción en su primer cierre
export const obtenerMotivoSinCierre = (siguienteCierre, nombrePadre) => {
    if (siguienteCierre.sin_produccion_desde_ultimo_cierre) {
        return (
            `No se ha registrado producción de ${nombrePadre} desde el último cierre ` +
            `(corte al ${formatearFecha(siguienteCierre.fecha_ultimo_corte)}), ` +
            "no se pueden registrar cierres mensuales."
        );
    }

    if (siguienteCierre.es_primer_cierre && !siguienteCierre.inicio_de_produccion) {
        return `Aún no se ha registrado producción de ${nombrePadre}, no se pueden registrar cierres mensuales.`;
    }

    return null;
};

// En el primer cierre del producto padre se elige el periodo inicial; en los
// siguientes, los periodos continúan desde el último incluido y los define la
// fecha de corte, siempre que haya producción desde el último cierre
export const obtenerTextoIndicacion = (siguienteCierre, nombrePadre) => {
    const motivoSinCierre = obtenerMotivoSinCierre(siguienteCierre, nombrePadre);

    if (motivoSinCierre) return motivoSinCierre;

    if (!siguienteCierre.es_primer_cierre) {
        return (
            `El último cierre (corte al ${formatearFecha(siguienteCierre.fecha_ultimo_corte)}) ` +
            `abarcó hasta el periodo ${siguienteCierre.ultimo_periodo_incluido}. ` +
            "Seleccione la fecha de corte para incluir los periodos siguientes."
        );
    }

    return `Este será el primer cierre mensual de producción de ${nombrePadre}. Seleccione el periodo inicial.`;
};
